module.exports = __webpack_public_path__ + "img/footer-instagram-icon.848119a9.svg";